import { Check, Clock, FileSignature, DollarSign, XCircle } from "lucide-react";
import { formatDateTime } from "@/lib/api";

const TIMELINE_STEPS = [
  { key: "created", label: "Solicitado", icon: Clock },
  { key: "approved", label: "Aprovado", icon: Check },
  { key: "signed", label: "Assinado", icon: FileSignature },
  { key: "paid", label: "Pago", icon: DollarSign },
];

function getTimelineState(anticipation) {
  const a = anticipation;
  const steps = TIMELINE_STEPS.map(s => ({ ...s, done: false, active: false, date: null }));

  // Step 1: Created (always done)
  steps[0].done = true;
  steps[0].date = a.created_at;

  // Check for cancelled/rejected
  if (a.status === "cancelado" || a.status === "recusado") {
    return { steps, cancelled: true, cancelLabel: a.status === "cancelado" ? "Cancelado" : "Recusado" };
  }

  // Step 2: Approved
  if (["aguardando_assinatura", "aguardando_pagamento", "liquidado"].includes(a.status) || a.approval_date) {
    steps[1].done = true;
    steps[1].date = a.approval_date;
  } else if (a.status === "aguardando_aprovacao" || a.status === "aguardando_aprovacao_zemo") {
    steps[1].active = true;
  }

  // Step 3: Signed
  if (["aguardando_pagamento", "liquidado"].includes(a.status) || a.signed_at) {
    steps[2].done = true;
    steps[2].date = a.signed_at;
  } else if (a.status === "aguardando_assinatura" || a.awaiting_signature) {
    steps[2].active = true;
  }

  // Step 4: Paid
  if (a.status === "liquidado") {
    steps[3].done = true;
    steps[3].date = a.paid_at;
  } else if (a.status === "aguardando_pagamento") {
    steps[3].active = true;
  }

  return { steps, cancelled: false };
}

export default function AnticipationTimeline({ anticipation }) {
  const { steps, cancelled, cancelLabel } = getTimelineState(anticipation);

  return (
    <div className="flex items-center gap-1 py-2" data-testid="anticipation-timeline">
      {steps.map((step, i) => (
        <div key={step.key} className="flex items-center flex-1">
          <div className="flex flex-col items-center flex-1">
            <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs ${
              step.done ? "bg-emerald-500/20 text-emerald-400" :
              step.active ? "bg-blue-500/20 text-blue-400 animate-pulse" :
              "bg-white/5 text-muted-foreground"
            }`}>
              <step.icon className="w-3 h-3" />
            </div>
            <span className={`text-[9px] mt-1 text-center leading-tight ${
              step.done ? "text-emerald-400" : step.active ? "text-blue-400" : "text-muted-foreground"
            }`}>{step.label}</span>
            {step.date && <span className="text-[8px] text-muted-foreground">{formatDateTime(step.date).split(" ")[0]}</span>}
          </div>
          {i < steps.length - 1 && (
            <div className={`h-px flex-1 mx-0.5 ${step.done ? "bg-emerald-500/30" : "bg-white/10"}`} />
          )}
        </div>
      ))}
      {cancelled && (
        <div className="flex flex-col items-center ml-1">
          <div className="w-6 h-6 rounded-full flex items-center justify-center bg-red-500/20 text-red-400">
            <XCircle className="w-3 h-3" />
          </div>
          <span className="text-[9px] mt-1 text-red-400">{cancelLabel}</span>
        </div>
      )}
    </div>
  );
}
